export const vehicleTypeOptions = [
  { value: "v1", label: "Alphard" },
  { value: "v2", label: "GC" },
  { value: "v3", label: "LC" },
  { value: "v4", label: "Granace" },
];

export const baggageOptions = [
  { value: "l4", label: "Check-in size" },
  { value: "l5", label: "Cabin size" },
];
export const paxOptions = [
  { value: "p1", label: "Adult" },
  { value: "p2", label: "Child" },
  { value: "p3", label: "Infant" },
];
export const options = [
  { value: "colombo1", label: "Park road 1, Pannipitiya" },
  { value: "colombo2", label: "Park road 2, Pannipitiya" },
  { value: "colombo3", label: "Park road 3, Pannipitiya" },
  { value: "colombo4", label: "Park road 4, Pannipitiya" },
  { value: "colombo5", label: "Park road 5, Pannipitiya" },
];
export const vehicleTypeImageOptions = [
  { value: "v1", label: "Alphard" },
  { value: "v2", label: "Grand-Cabin" },
  { value: "v3", label: "Luxury-Cabin" },
  { value: "v4", label: "Granace" },
  { value: "v5", label: "Benz V Class" },
];

export const bookingStatusOptions = [
  { value: "s1", label: "INQUIRY" },
  { value: "s2", label: "PAYMENT_PENDING" },
  { value: "s3", label: "CONFIRMED" },
  { value: "s4", label: "CANCELLED" },
];

export const newBookingStatusOptions = [
  {
    value: "PENDING_CONFIRMATION",
    label: "Pending Confirmation",
    bookingStatus: "CONFIRMED",
    paymentStatus: ["CHARGE_PENDING"],
  },
  {
    value: "CONFIRMED",
    label: "Confirmed",
    bookingStatus: "CONFIRMED",
    paymentStatus: ["CHARGED", "ADDED_TO_MONTHLY_TOTAL"],
  },
  {
    value: "CANCELLED",
    label: "Cancelled",
    bookingStatus: "CANCELLED",
    paymentStatus: [],
  },
];

export const newPaymentStatusOptions = [
  { value: "CHARGE_PENDING", label: "Charge Pending" },
  { value: "CHARGE_INITIATED", label: "Charge Initiated" },
  { value: "CHARGED", label: "Charged" },
  { value: "CHARGE_FAILED", label: "Charge failed" },
];

export const newBookingTypeOptions = [
  { value: "specifiedDestination", label: "Specified Destination" },
  { value: "byTheHour", label: "By The Hour" },
];

export const bookingTypeOptions = [
  // { value: "b1", label: "Admin" },
  { value: "b2", label: "Online" },
];

export const iconTypes = [
  { value: "i1", label: "Passengers icon" },
  { value: "i2", label: "Suitcases icon" },
  { value: "i3", label: "Mobile device charger icon" },
  { value: "i4", label: "television" },
  { value: "i4", label: "In-car wifi" },
  { value: "i4", label: "DVD-player icon" },
];

export const travelAreaOptions = [
  {
    value: "withinCity",
    label: "ByTheHour.TravelArea.WithinCity",
  },
  {
    value: "neighboringPerfecture",
    label: "ByTheHour.TravelArea.NeighboringPerfecture",
  },
  {
    value: "undecided",
    label: "ByTheHour.TravelArea.Undecided",
  },
];

export const travelAreaOptionsEnglish = [
  {
    value: "withinCity",
    label: "Within the city/prefecture",
  },
  {
    value: "neighboringPerfecture",
    label: "To the neighboring city/prefecture",
  },
  {
    value: "undecided",
    label: "Undecided",
  },
];

export const sortByMyPageBookings = [
  {
    value: "desc",
    label: {
      en: "Pickup Date ・ Latest → Oldest",
      jp: "ご利用日の新しい順"
    },
  },
  {
    value: "asc",
    label: {
      en: "Pickup Date ・ Oldest → Latest",
      jp: "ご利用日の古い順"
    },
  },
];

export const usageDurationOptions = [
  { label: '00 Hour 30 Minutes', value: '0.5' },
  { label: '01 Hour 00 Minutes', value: '1' },
  { label: '01 Hour 30 Minutes', value: '1.5' },
  { label: '02 Hour 00 Minutes', value: '2' },
  { label: '02 Hour 30 Minutes', value: '2.5' },
  { label: '03 Hour 00 Minutes', value: '3' },
  { label: '03 Hour 30 Minutes', value: '3.5' },
  { label: '04 Hour 00 Minutes', value: '4' },
  { label: '04 Hour 30 Minutes', value: '4.5' },
  { label: '05 Hour 00 Minutes', value: '5' },
  { label: '05 Hour 30 Minutes', value: '5.5' },
  { label: '06 Hour 00 Minutes', value: '6' },
  { label: '06 Hour 30 Minutes', value: '6.5' },
  { label: '07 Hour 00 Minutes', value: '7' },
  { label: '07 Hour 30 Minutes', value: '7.5' },
  { label: '08 Hour 00 Minutes', value: '8' },
  { label: '08 Hour 30 Minutes', value: '8.5' },
  { label: '09 Hour 00 Minutes', value: '9' },
  { label: '09 Hour 30 Minutes', value: '9.5' },
  { label: '10 Hour 00 Minutes', value: '10' },
  { label: '10 Hour 30 Minutes', value: '10.5' },
  { label: '11 Hour 00 Minutes', value: '11' },
  { label: '11 Hour 30 Minutes', value: '11.5' },
  { label: '12 Hour 00 Minutes', value: '12' },
  { label: '12 Hour 30 Minutes', value: '12.5' },
  { label: '13 Hour 00 Minutes', value: '13' },
  { label: '13 Hour 30 Minutes', value: '13.5' },
  { label: '14 Hour 00 Minutes', value: '14' },
  { label: '14 Hour 30 Minutes', value: '14.5' },
  { label: '15 Hour 00 Minutes', value: '15' },
  { label: '15 Hour 30 Minutes', value: '15.5' },
  { label: '16 Hour 00 Minutes', value: '16' },
  { label: '16 Hour 30 Minutes', value: '16.5' },
  { label: '17 Hour 00 Minutes', value: '17' },
  { label: '17 Hour 30 Minutes', value: '17.5' },
  { label: '18 Hour 00 Minutes', value: '18' },
  { label: '18 Hour 30 Minutes', value: '18.5' },
  { label: '19 Hour 00 Minutes', value: '19' },
  { label: '19 Hour 30 Minutes', value: '19.5' },
  { label: '20 Hour 00 Minutes', value: '20' },
  { label: '20 Hour 30 Minutes', value: '20.5' },
  { label: '21 Hour 00 Minutes', value: '21' },
  { label: '21 Hour 30 Minutes', value: '21.5' },
  { label: '22 Hour 00 Minutes', value: '22' },
  { label: '22 Hour 30 Minutes', value: '22.5' },
  { label: '23 Hour 00 Minutes', value: '23' },
  { label: '23 Hour 30 Minutes', value: '23.5' },
  { label: '24 Hour 00 Minutes', value: '24' }
];

export const sortByMyPageQuotations = [
  {
    value: "issueDate,desc",
    label: "Issue Date ・ Latest → Oldest",
  },
  {
    value: "issueDate,asc",
    label: "Issue Date ・ Oldest → Latest",
  },
  {
    value: "expiredDate,desc",
    label: "Expired Date ・ Latest → Oldest",
  },
  {
    value: "expiredDate,asc",
    label: "Expired Date ・ Oldest → Latest",
  },
  {
    value: "name,asc",
    label: "name ・ A → Z",
  },
  {
    value: "name,desc",
    label: "name ・ Z → A",
  },
];

// 1 hour	3600 seconds
// 1 day	86400 seconds
// 1 week	604800 seconds
// 1 month (30.44 days) 	2629743 seconds
// 1 year (365.24 days) 	 31556926 seconds

export const myPageMenu = {
  "individual": [
    {
      name: "bookings",
      link: "/my-page/bookings",
      defaultParams: "?content=upcoming",
      tag: "myPage.navbar.booking"
    },
    {
      name: "notifications",
      link: "/my-page/notifications",
      defaultParams: "",
      tag: "myPage.navbar.notification"
    },
    {
      name: "account",
      link: "/my-page/account",
      defaultParams: "",
      tag: "myPage.navbar.accountInformation"
    },
  ],
  "business": [
    {
      name: "bookings",
      link: "/my-page/bookings",
      defaultParams: "?content=upcoming",
      tag: "myPage.navbar.booking"
    },
    {
      name: "quotations",
      link: "/my-page/quotations",
      defaultParams: "",
      tag: "myPage.navbar.quotation"
    },
    {
      name: "notifications",
      link: "/my-page/notifications",
      defaultParams: "",
      tag: "myPage.navbar.notification"
    },
    // {
    //   name: "invoice",
    //   link: "/my-page/invoices-billings",
    //   defaultParams: "",
    //   tag: "myPage.navbar.invoiceAndBilling"
    // },
    // {
    //   name: "clientlist",
    //   link: "/my-page/client-list",
    //   defaultParams: "",
    //   tag: "myPage.navbar.clientList"
    // },
    {
      name: "account",
      link: "/my-page/account",
      defaultParams: "",
      tag: "myPage.navbar.accountInformation"
    },
  ]
}

export const bookingSubMenu = {
  "individual": [
    {
      name: "current",
      params: "?content=upcoming",
      tag: "myPage.booking.subMenu.upcomingBookings"
    },
    {
      name: "previous",
      params: "?content=previous",
      tag: "myPage.booking.subMenu.previousBookings"
    },
    {
      name: "cancelled",
      params: "?content=cancelled",
      tag: "myPage.booking.subMenu.cancelledBookings"
    },
  ],
  "business": [
    // {
    //   name: "this_month",
    //   params: "?content=this_month",
    //   tag: "myPage.booking.subMenu.thisMonthBookings"
    // },
    {
      name: "upcoming",
      params: "?content=upcoming",
      tag: "myPage.booking.subMenu.upcomingBookings"
    },
    {
      name: "previous",
      params: "?content=previous",
      tag: "myPage.booking.subMenu.previousBookings"
    },
    {
      name: "cancelled",
      params: "?content=cancelled",
      tag: "myPage.booking.subMenu.cancelledBookings"
    },
  ]
}

export const businessData = [
  {
    value: "IT, Telecommunications & Internet",
    label: "businessRegister.businessInformation.options.businessIndustry.it",
  },
  {
    value: "Manufacturing",
    label: "businessRegister.businessInformation.options.businessIndustry.manufacturing",
  },
  {
    value: "Trading Companies",
    label: "businessRegister.businessInformation.options.businessIndustry.trading",
  },
  {
    value: "Services & Leisure",
    label: "businessRegister.businessInformation.options.businessIndustry.service",
  },
  {
    value: "Distribution, Retail & Food",
    label: "businessRegister.businessInformation.options.businessIndustry.distribution",
  },
  {
    value: "Mass Media, Advertising & Design",
    label: "businessRegister.businessInformation.options.businessIndustry.massMedia",
  },
  {
    value: "Finance & Insurance",
    label: "businessRegister.businessInformation.options.businessIndustry.finance",
  },
  {
    value: "Consulting",
    label: "businessRegister.businessInformation.options.businessIndustry.consulting",
  },
  {
    value: "Real Estate, Construction & Facilities",
    label: "businessRegister.businessInformation.options.businessIndustry.realEstate",
  },
  {
    value: "Transportation, Logistics & Warehousing",
    label: "businessRegister.businessInformation.options.businessIndustry.transportation",
  },
  {
    value: "Environment & Energy",
    label: "businessRegister.businessInformation.options.businessIndustry.environment",
  },
  {
    value: "Public Institutions",
    label: "businessRegister.businessInformation.options.businessIndustry.publicInstitution",
  },
  {
    value: "Others",
    label: "businessRegister.businessInformation.options.businessIndustry.other",
  }
];

export const businessTypeData = [
  {
    value: "Joint Stock Company",
    label: "businessRegister.businessInformation.options.businessType.joint",
  },
  {
    value: "Limited Liability Company",
    label: "businessRegister.businessInformation.options.businessType.limitedLiability",
  },
  {
    value: "Limited Partnership",
    label: "businessRegister.businessInformation.options.businessType.limitedPartnership",
  },
  {
    value: "General Partnership",
    label: "businessRegister.businessInformation.options.businessType.generalPartnership",
  },
  {
    value: "Others",
    label: "businessRegister.businessInformation.options.businessType.other",
  }
];

export const optionsPronounce = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Mrs.', label: 'Mrs.' }
]

// Honorifics are saved as plain strings ("Mr."), but the select (react-select)
// needs the whole option object to show it as selected. Returns null when the
// value is empty or unknown, so the select shows its placeholder.
export const findPronounceOption = (pronounceValue) =>
  optionsPronounce.find((option) => option.value === pronounceValue) || null;

export const userStatusOptions = [
  { value: "PENDING_VERIFICATION", label: "Pending Verification" },
  { value: "PENDING_APPROVAL", label: "Pending Approval" },
  { value: "ACTIVE", label: "Active" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DEACTIVE", label: "Deactivated" },
];
